import React, { Component } from 'react'
import Hero from '../components/Hero'
import Banner from '../components/Banner'
import { Link } from 'react-router-dom'
import Services from '../components/Services'
import FeaturedMenu from '../components/FeaturedMenu'
import Dialog from '../components/Dialog'
export default class Home extends Component {
    state = {
        modalIsOpen: true
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <>
                <Dialog modalIsOpen={this.state.modalIsOpen} modalOnClose={(e) => this.setState({ modalIsOpen: false })}>
                </Dialog>
                <Hero>
                    <Banner title="Ozen Sushi" subtitle="party tray starting from $40">
                        <Link to='/Menu' className="btn-primary">
                            <font color="white"> see all menu</font>
                        </Link>
                    </Banner>
                </Hero>
                <Services />
                <FeaturedMenu />

            </>
        )
    }

}
